/**
 * Check Vulnerability
 *
 * @param {array} list
 * @param {string} type
 */
function spbcCheckVulnerability(list, type = 'install') {
    let data = {};
    data.security = spbcSettings.ajax_nonce;
    data.action = type === 'install' ? 'spbc_check_vulnerability_install' : 'spbc_check_vulnerability_list';
    data.list = list;

    jQuery.ajax({
        type: 'POST',
        async: false,
        url: spbcSettings.ajaxurl,
        data: data,
        success: function(result) {
            if (result.success) {
                if (type === 'install') {
                    spbcCheckVulnerabilityInstallRender(result.list, result.msg);
                }
                if (type === 'list') {
                    spbcCheckVulnerabilityListRender(result.list);
                }
            } else {
                console.log(result);
            }
        },
    });
}

/**
 * Check Vulnerability List Render
 *
 * @param {object} list
 * @param {string} msg
 */
function spbcCheckVulnerabilityListRender(list) {
    let card;
    let badge;

    list.forEach((el) => {
        badge = document.createElement('div');
        badge.classList.add('notice', 'notice-error', 'error-message', 'spbc-vulnerable-notice');
        badge.innerHTML = el.msg;
        card = document.querySelector('.themes .theme[data-slug=' + el.slug + ']');
        if (card) {
            card.appendChild(badge);
        }
    });
}

/**
 * Check Vulnerability Install Render
 *
 * @param {object} list
 * @param {string} msg
 */
function spbcCheckVulnerabilityInstallRender(list, msg) {
    let card;

    let badge = document.createElement('div');
    badge.classList.add('notice');
    badge.innerHTML = '<p>' + msg + '</p>';

    list.forEach((el) => {
        card = document.querySelector('.theme-id-container .theme-actions a[data-slug=' + el + ']');
        if (card) {
            card.parentNode.parentNode.parentNode.appendChild(badge);
        }
    });
}

jQuery(document).ready(function() {
    if (window.location.href.indexOf('themes.php') > -1 && spbcSettings.vulnerabilityShowList) {
        let slugsState = [];
        let slugs = [];
        let slugsNodes;
        let version;

        setInterval(function() {
            slugsNodes = document.querySelectorAll('.themes .theme[data-slug]');

            if (slugsNodes.length > 0) {
                slugs = [];
                slugsNodes.forEach(function(el) {
                    version = el.querySelector('img').src ?
                        el.querySelector('img').src.match(/ver=([\d\.]+)/)[1] :
                        null;
                    slugs.push({'slug': el.dataset.slug, 'version': version});
                });
            }

            if (JSON.stringify(slugs) != JSON.stringify(slugsState)) {
                slugsState = slugs;
                spbcCheckVulnerability(slugs, 'list');
            }
        }, 500);
    }

    if (window.location.href.indexOf('theme-install.php') > -1 && spbcSettings.vulnerabilityShowInstall) {
        let slugsState = [];
        let slugs = [];
        let slugsNodes;

        setInterval(function() {
            slugsNodes = document.querySelectorAll('.theme-id-container .theme-actions a[data-slug]');

            if (slugsNodes.length > 0) {
                slugs = [];
                slugsNodes.forEach(function(el) {
                    slugs.push(el.dataset.slug);
                });
            }

            if (JSON.stringify(slugs) != JSON.stringify(slugsState)) {
                slugsState = slugs;
                spbcCheckVulnerability(slugs);
            }
        }, 500);
    }

    // Auto update banner close handler
    jQuery('.spbc_update_notice').on('click', 'button', function() {
        spbcSetCookie('spbc_update_banner_closed', 1, 86400 * 30);
    });

    let refreshUserOnlineCounter = function( result, data, params ) {
        setTimeout(function() {
            if ( result !== null ) {
                jQuery('.spbc-admin_bar--user_counter').html(result.count);
                if ( result.count <= 3 ) {
                    jQuery('#wp-admin-bar-spbc_admin_bar__online_admins').show();
                    jQuery('.spbc-admin_bar--online_admins').html(result.users.join(', '));
                } else {
                    jQuery('#wp-admin-bar-spbc_admin_bar__online_admins').hide();
                }
            }
            spbcSendAJAXRequest( data, params );
        }, 15000 );
    };

    if ( +spbcSettings.admin_bar__admins_online_counter === 1 ) {
        refreshUserOnlineCounter(null, {action: 'spbc_get_authorized_admins'}, {callback: refreshUserOnlineCounter});
    }

    // Dismiss admin banner
    spbcHandleBannersDismissing();

    if (+spbcSettings.needToWhitelist === 1) {
        spbcSendAJAXRequest( {'action': 'spbc_private_list_add'}, {'callback': null} );
    }

    if ( +spbcSettings.critical > 0) {
        let ringContainer = document.createElement('div');
        ringContainer.className = 'spbc_ring-container';
        ringContainer.style.top = '0px';
        ringContainer.style.right = '70px';
        let ringRing = document.createElement('div');
        ringRing.className = 'spbc_ringring';
        let circle = document.createElement('div');
        circle.className = 'spbc_circle';

        ringContainer.appendChild(ringRing);
        ringContainer.appendChild(circle);

        let settings = document.querySelector('#menu-settings');
        if (settings) {
            settings.appendChild(ringContainer);
        }
    }

    jQuery(document).on('keyup', '#spbc_key', function(e) {
        e.preventDefault();
        let value = jQuery('#spbc_key').val();
        if (/^[a-zA-Z0-9]+$/.test(value) && value.length > 8) {
            jQuery('#spbc-key-manually-link').hide();
            jQuery('#spbc_setting_get_key_auto').hide();
            jQuery('#spbc_get_key_or_text').hide();
        } else {
            jQuery('#spbc-key-manually-link').show();
            jQuery('#spbc_setting_get_key_auto').show();
            jQuery('#spbc_get_key_or_text').show();
        }
    });

    if (spbcSettings['wl_mode_enabled']) {
        // any usage of non WL name
        jQuery('.plugin-title strong').each( function(i, item) {
            if (jQuery(item).html().indexOf('Security by CleanTalk') >= 0) {
                jQuery(item).html(jQuery(item).html().replace('CleanTalk', spbcSettings['wl_company_name']));
            }
        });
        // Edit plugin update chunks and links
        const updateLink = jQuery(
            '.plugin-update-tr[data-slug="security-malware-firewall"] .open-plugin-details-modal',
        );
        const updateText = updateLink.text();
        const version = updateText.match(/version (\d+\.\d+)/i)?.[1];
        updateLink.remove();
        jQuery('.plugin-update-tr[data-slug="security-malware-firewall"] p').each(function() {
            let href = jQuery(
                `.plugin-update-tr[data-slug="security-malware-firewall"]
                a[aria-label="Update Security by CleanTalk now"]`,
            );
            const textToReplace = 'Update now to ' + version;
            href.text(textToReplace);
            jQuery(this).text(jQuery(this).text().replace('  or ', ''));
            jQuery(this).text(jQuery(this).text().replace(textToReplace + '.', ' '));
            jQuery(this).append(href);
        });
    }

    // Users pass check
    if (window.location.href.indexOf('users.php') > -1) {
        // check if url contains user_ids
        if (document.querySelector('#spbc_pass_check')) {
            spbcGetPassLeak();
        }
    }
});

/**
 * Get pass leak
 */
function spbcGetPassLeak() {
    let data = {};
    data.security = spbcSettings.ajax_nonce;
    data.action = 'spbc_check_pass_leak';
    data.user_ids = [];

    let users = document.querySelectorAll('table.users #the-list tr[id]');
    users.forEach((el) => data.user_ids.push(el.getAttribute('id').split('-')[1]));

    jQuery.ajax({
        type: 'POST',
        async: false,
        url: spbcSettings.ajaxurl,
        data: data,
        success: function(result) {
            document.querySelectorAll('table.users #the-list tr[id]').forEach((el) => {
                const userId = el.getAttribute('id').split('-')[1];
                if (result.data[userId]) {
                    let span = document.createElement('span');
                    span.textContent = result.data[userId].text;

                    if (result.data[userId].status === 'safe') {
                        span.classList.add('spbcGreen');
                        let img = document.createElement('img');
                        img.src = spbcSettings.img_path + '/yes.png';
                        img.style.marginLeft = '5px';
                        span.appendChild(img);
                    }
                    if (result.data[userId].status === 'leaked') {
                        console.log(result.data[userId]);
                        span.classList.add('spbcRed');
                        let icon = document.createElement('i');
                        icon.classList.add('spbc-icon-attention-alt');
                        icon.style.backgroundColor = '#d63638';
                        icon.style.color = '#fff';
                        icon.style.borderRadius = '50%';
                        icon.style.fontSize = '10px';
                        icon.style.padding = '2px';
                        icon.style.marginLeft = '5px';
                        span.appendChild(icon);
                    }

                    el.querySelector('.column-spbc_pass_check').appendChild(span);
                }
            });
        },
    });
}

/**
 * Summary Show CDN Checker Table
 */
function spbcSummaryShowCDNCheckerTable() {/* eslint-disable-line no-unused-vars */
    event.preventDefault();
    let table = document.getElementById('spbc_stats_cdn_checker_table');
    if (typeof (table) !== 'undefined') {
        if (table.style.display === 'block') {
            table.style.display = 'none';
        } else {
            table.style.display = 'block';
        }
    }
}

/**
 * Dismiss function for banners.
 */
function spbcHandleBannersDismissing() {
    let body = jQuery('body');
    body.on('click', '.spbct-notice-dismiss-link', function(e) {
        jQuery(e.target).siblings('.notice-dismiss').click();
    });
    body.on('click', '.spbc-notice .notice-dismiss', function(e) {
        const bannerId = jQuery(e.target).parent('.notice').attr('id');
        if (bannerId) {
            // call ajax to dismiss banner anyway
            // todo There is no case when further API call for notice_review is unsuccessful,
            // todo but it should be handled in the future
            spbcSendAJAXRequest({'action': 'spbc_dismiss_banner', 'banner_id': bannerId}, {});

            // check if there is a postNoticeText to show after dismissing the notice
            if (
                typeof spbcSettings !== 'undefined' &&
                spbcSettings.hasOwnProperty('spbctNoticeDismissSuccess')
            ) {
                // get afterDismissingNotices from localized settings
                let afterDismissingNotices = spbcSettings.spbctNoticeDismissSuccess;
                // default postNoticeText
                let postNoticeText = '';
                // default notice level
                let noticeLevel = '';
                if (typeof afterDismissingNotices === 'string') {
                    // try to parse JSON
                    try {
                        afterDismissingNotices = JSON.parse(afterDismissingNotices);
                    } catch (e) {
                        afterDismissingNotices = [];
                    }
                    // get postNoticeText and noticeLevel according to bannerName
                    for (const afterDismissingNotice of afterDismissingNotices) {
                        if (
                            afterDismissingNotice.hasOwnProperty('bannerName') &&
                            afterDismissingNotice.hasOwnProperty('postNoticeText')
                        ) {
                            let bannerName = afterDismissingNotice.bannerName;
                            // if banner name is in the bannerId, show the postNoticeText
                            if (bannerId.indexOf(bannerName) !== -1) {
                                postNoticeText = afterDismissingNotice.postNoticeText;
                            }
                            // if noticeLevel is set, use it
                            if (afterDismissingNotice.hasOwnProperty('noticeLevel')) {
                                noticeLevel = afterDismissingNotice.noticeLevel;
                            }
                        }
                    }
                }

                // if postNoticeText is set, show it
                if (postNoticeText !== '') {
                    const noticeClassList = 'notice ' + noticeLevel + ' is-dismissible';
                    let elem = '<div id="spbct-notice-dismiss-success" class="' + noticeClassList + '">' +
                            '<p>' +
                            postNoticeText +
                            '</p></div>';
                    jQuery(e.target)
                        .parent('.notice')
                        .after(elem);
                    setTimeout(function() {
                        jQuery('#spbct-notice-dismiss-success').fadeOut();
                    }, 5000);
                }
            }
        }
    });
}

// eslint-disable-next-line no-unused-vars
/**
 * Highlights the critical files notice if the URL contains specific parameters.
 *
 * @param {boolean} [isBannerCall=false] - Indicates if the function is called from a banner.
 *
 */
function spbcHighlightCriticalFilesNotice(isBannerCall = false) { // eslint-disable-line no-unused-vars
    // Check if the URL contains the parameters to highlight the notice
    let needToHighlightNotice = window.location.href.indexOf('spbc_tab=scanner&highlight_critical_files=1') !== -1;
    let redirectConditionIsOK = window.location.href.indexOf('spbc_tab=scanner') === -1;

    // Redirect to the scanner tab if called from a banner and the condition is met
    if (isBannerCall && redirectConditionIsOK) {
        window.location.href = 'options-general.php?page=spbc&spbc_tab=scanner&highlight_critical_files=1';
        return;
    }

    // If the notice needs to be highlighted
    if (needToHighlightNotice || isBannerCall) {
        let criticalFilesNotice = null;
        let criticalFilesNotices = document.querySelectorAll('#notice_id_found_critical_files');

        // Find the critical files notice within the scanner tab
        if (criticalFilesNotices.length > 0) {
            criticalFilesNotices.forEach((notice) => {
                if (criticalFilesNotice == null) {
                    if (notice.closest('#spbc_tab-scanner') !== null) {
                        criticalFilesNotice = notice;
                    }
                }
            });
        }
        // Scroll to the notice and highlight it with a blinking effect
        if (criticalFilesNotice !== null) {
            criticalFilesNotice.scrollIntoView({behavior: 'smooth', block: 'start'});
            if (!criticalFilesNotice.hasOwnProperty('highlighted')) {
                let switcher = false;
                setInterval(() => {
                    switcher = !switcher;
                    if (switcher) {
                        criticalFilesNotice.classList.remove('notice-warning');
                        criticalFilesNotice.classList.add('notice-error');
                        criticalFilesNotice.highlighted = true;
                    } else {
                        criticalFilesNotice.classList.remove('notice-error');
                        criticalFilesNotice.classList.add('notice-warning');
                    }
                }, 1000);
            }
        }

        // Expand the critical files table if it exits and is collapsed
        let criticalFileTable = document.querySelector('h3[aria-controls="spbc_scan_accordion_tab_critical"]');
        if (criticalFileTable !== null) {
            if (!criticalFileTable.classList.contains('ui-accordion-header-active')) {
                criticalFileTable.click();
            }
        } else {
            // Check periodically if the table is loaded and expand it
            const tabLoadingCheckInterval = setInterval(() => {
                criticalFileTable = document.querySelector('h3[aria-controls="spbc_scan_accordion_tab_critical"]');
                if (criticalFileTable !== null) {
                    if (!criticalFileTable.classList.contains('ui-accordion-header-active')) {
                        criticalFileTable.click();
                    }
                    clearInterval(tabLoadingCheckInterval);
                }
            }, 150);
        }
    }
}
